export default {
      id: "color_guy1-usage",
      viewBox: "0 0 137 219",
      url: __webpack_public_path__ + "sprite.svg#color_guy1",
      toString: function () {
        return this.url;
      }
    }